import { Injectable } from '@angular/core';
import { PlatformSettingsConfig } from './platform-settings-url.config';
import { HttpService } from '@app/@core/services/http.service';

@Injectable({
  providedIn: 'root'
})
export class PlatformSettingsService {
  constructor(private httpService: HttpService) {
    //Intentional
  }
  getConfigList() {
    return this.httpService.get(PlatformSettingsConfig.EndPoint.ConfigSettings.getConfigList);
  }
  getConfigById(id) {
    return this.httpService.get(PlatformSettingsConfig.EndPoint.ConfigSettings.getConfigById + id);
  }
  saveConfigSettings(modal) {
    return this.httpService.post(PlatformSettingsConfig.EndPoint.ConfigSettings.saveConfig, modal);
  }
  updateConfig(id, modal) {
    return this.httpService.patch(PlatformSettingsConfig.EndPoint.ConfigSettings.updateConfig + id, modal);
  }
  getAllDatetimeFormatList() {
    return this.httpService.get(PlatformSettingsConfig.EndPoint.ConfigSettings.datetimeFomrat);
  }

  getAllTimezoneList() {
    return this.httpService.get(PlatformSettingsConfig.EndPoint.ConfigSettings.timezone);
  }

  getConfigurationsByOrgId(id) {
    return this.httpService.get(PlatformSettingsConfig.EndPoint.ConfigSettings.getConfigurationsByOrgId + id);
  }
}
